module.exports = __webpack_public_path__ + "static/media/grid-chart-solid.47e35abe.svg";